<template>
  <div>
    <v-menu
      content-class="user-profile-menu-content"
      left
      min-width="230"
      nudge-bottom="14"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
        >
          <v-avatar
            :color="!picture ? 'white' : ''"
            size="40"
          >
            <b
              v-if="!picture"
              class="accent--text font-weight-semibold"
            >
              {{ initialName }}
            </b>

            <v-img
              v-else
              :src="picture"
            />
          </v-avatar>

          <div
            class="d-inline-flex flex-column justify-center ms-3"
            style="vertical-align:middle"
          >
            <span class="white--text font-weight-semibold mb-n1">
              {{ username }}
            </span>
          </div>
        </div>
      </template>
      <v-list>
        <div class="pb-3 pt-2">
          <v-badge
            bottom
            class="ms-4"
            color="success"
            dot
            offset-x="12"
            offset-y="12"
            overlap
          >
            <v-avatar
              color="primary"
              size="40"
            >
              <b class="white--text font-weight-semibold">
                {{ initialName }}
              </b>
            </v-avatar>
          </v-badge>
          <div
            class="d-inline-flex flex-column justify-center ms-3"
            style="vertical-align:middle"
          >
            <span class="text--primary font-weight-semibold mb-n1">
              {{ username }}
            </span>
          </div>
        </div>

        <v-divider class="my-2" />

        <v-list-item @click="openMyData">
          <v-list-item-icon class="me-2">
            <v-icon
              class="primary--text"
              size="22"
            >
              {{ icons.mdiAccountCircleOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Meus dados</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2" />
        <v-list-item @click="openFormChangePassword">
          <v-list-item-icon class="me-2">
            <v-icon
              class="primary--text"
              size="22"
            >
              {{ icons.mdiKey }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Alterar senha</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2" />

        <v-list-item
          link
          @click="logout"
        >
          <v-list-item-icon class="me-2">
            <v-icon
              class="primary--text"
              size="22"
            >
              {{ icons.mdiLogoutVariant }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Sair
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- Meus dados dialog -->
    <v-dialog
      v-model="myDataDialog"
      max-width="460"
    >
      <v-card>
        <div class="profile-header pa-6 pb-5">
          <div class="d-flex align-center">
            <v-avatar
              color="primary"
              size="56"
              class="elevation-3 me-4"
            >
              <span class="white--text text-h6 font-weight-bold">{{ initialName }}</span>
            </v-avatar>
            <div>
              <h3
                class="font-weight-bold mb-0"
                style="font-size: 1.1rem;"
              >
                {{ userData.name || username }}
              </h3>
              <p class="text--secondary mb-0 text-caption">
                {{ userData.email }}
              </p>
            </div>
            <v-spacer />
            <v-btn
              icon
              small
              @click="myDataDialog = false"
            >
              <v-icon size="20">
                {{ icons.mdiClose }}
              </v-icon>
            </v-btn>
          </div>
        </div>

        <v-divider />

        <v-card-text class="pa-5">
          <v-row dense>
            <v-col cols="12">
              <div class="info-row">
                <v-icon
                  size="16"
                  class="me-2 info-icon"
                >
                  {{ icons.mdiAccount }}
                </v-icon>
                <div>
                  <p class="info-label">
                    Nome completo
                  </p>
                  <p class="info-value">
                    {{ userData.name || '—' }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="info-row">
                <v-icon
                  size="16"
                  class="me-2 info-icon"
                >
                  {{ icons.mdiEmailOutline }}
                </v-icon>
                <div>
                  <p class="info-label">
                    E-mail
                  </p>
                  <p class="info-value">
                    {{ userData.email || '—' }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <div class="info-row">
                <v-icon
                  size="16"
                  class="me-2 info-icon"
                >
                  {{ icons.mdiPhone }}
                </v-icon>
                <div>
                  <p class="info-label">
                    Telefone
                  </p>
                  <p class="info-value">
                    {{ userData.phone || '—' }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              sm="6"
            >
              <div class="info-row">
                <v-icon
                  size="16"
                  class="me-2 info-icon"
                >
                  {{ icons.mdiCardAccountDetailsOutline }}
                </v-icon>
                <div>
                  <p class="info-label">
                    CPF / CNPJ
                  </p>
                  <p class="info-value">
                    {{ userData.document ? $cpfCnpj.toMask(userData.document) : '—' }}
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <div class="info-row">
                <v-icon
                  size="16"
                  class="me-2 info-icon"
                >
                  {{ icons.mdiHandshakeOutline }}
                </v-icon>
                <div>
                  <p class="info-label">
                    Afiliado
                  </p>
                  <v-chip
                    x-small
                    :color="userData.isAffiliate ? 'primary' : 'default'"
                    :outlined="!userData.isAffiliate"
                    style="border-radius: 4px;"
                  >
                    {{ userData.isAffiliate ? 'Sim' : 'Não' }}
                  </v-chip>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 gap-2">
          <v-btn
            text
            small
            color="primary"
            :to="'/account/wallet-extract'"
            @click="myDataDialog = false"
          >
            <v-icon
              left
              size="16"
            >
              {{ icons.mdiWallet }}
            </v-icon>
            Ver saldo
          </v-btn>
          <v-btn
            text
            small
            color="primary"
            @click="myDataDialog = false; openFormChangePassword()"
          >
            <v-icon
              left
              size="16"
            >
              {{ icons.mdiKey }}
            </v-icon>
            Alterar senha
          </v-btn>
          <v-spacer />
          <v-btn
            small
            outlined
            @click="myDataDialog = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <validation-observer
      ref="changePassword"
      autocomplete="off"
      tag="form"
    >
      <dialog-form
        :status="formDialogStatus"
        :width="440"
        title="Alterar senha"
        @remove="removeDialogStatus = true"
        @close="formDialogStatus = !formDialogStatus"
        @action="submit"
      >
        <!-- Header visual -->
        <div class="d-flex align-center mb-5">
          <v-avatar
            size="44"
            color="primary"
            rounded
            class="elevation-1 me-3"
          >
            <v-icon
              color="white"
              size="24"
            >
              {{ icons.mdiKey }}
            </v-icon>
          </v-avatar>
          <div>
            <p
              class="font-weight-semibold mb-0"
              style="font-size: 0.9rem;"
            >
              Segurança da conta
            </p>
            <p
              class="text--secondary mb-0"
              style="font-size: 0.75rem;"
            >
              Escolha uma senha forte e única
            </p>
          </div>
        </div>

        <v-divider class="mb-5" />

        <!-- Senha atual -->
        <validation-provider
          v-slot="{ errors }"
          name="Senha atual"
          rules="required"
          vid="currentPassword"
        >
          <v-text-field
            v-model="form.currentPassword"
            :error-messages="errors"
            :append-icon="isPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
            :type="isPasswordVisible ? 'text' : 'password'"
            :prepend-inner-icon="icons.mdiLockOutline"
            label="Senha atual"
            outlined
            dense
            hide-details="auto"
            class="mb-4"
            @click:append="isPasswordVisible = !isPasswordVisible"
          />
        </validation-provider>

        <v-divider class="mb-4" />

        <!-- Nova senha -->
        <validation-provider
          v-slot="{ errors }"
          rules="required"
          name="Nova Senha"
          vid="newPassword"
        >
          <v-text-field
            v-model="form.newPassword"
            :error-messages="errors"
            :append-icon="isNewPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
            :type="isNewPasswordVisible ? 'text' : 'password'"
            :prepend-inner-icon="icons.mdiLockReset"
            label="Nova senha"
            outlined
            dense
            hide-details="auto"
            class="mb-4"
            @click:append="isNewPasswordVisible = !isNewPasswordVisible"
          />
        </validation-provider>

        <!-- Confirmação -->
        <validation-provider
          v-slot="{ errors }"
          name="Confirmação da nova senha"
          rules="required|confirmed:newPassword"
          vid="newPasswordConfirmation"
        >
          <v-text-field
            v-model="form.newPasswordConfirmation"
            :error-messages="errors"
            :append-icon="isConfirmPasswordVisible ? icons.mdiEyeOffOutline : icons.mdiEyeOutline"
            :type="isConfirmPasswordVisible ? 'text' : 'password'"
            :prepend-inner-icon="icons.mdiLockCheck"
            label="Confirmar nova senha"
            outlined
            dense
            hide-details="auto"
            @click:append="isConfirmPasswordVisible = !isConfirmPasswordVisible"
          />
        </validation-provider>
      </dialog-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  mdiAccount,
  mdiAccountCircleOutline,
  mdiLogoutVariant,
  mdiWallet,
  mdiKey,
  mdiEyeOffOutline,
  mdiEyeOutline,
  mdiLockOutline,
  mdiLockReset,
  mdiLockCheck,
  mdiClose,
  mdiEmailOutline,
  mdiPhone,
  mdiCardAccountDetailsOutline,
  mdiHandshakeOutline,
} from '@mdi/js'
import { ref, reactive } from 'vue'
import { mapActions } from 'vuex'
import { extend } from 'vee-validate'
import { required, confirmed, sameAs } from 'vee-validate/dist/rules'
import { changePassword } from '@/store/auth/actions'

extend('confirmed', {
  ...confirmed,
  message: 'As senhas devem ser iguais.',
})
export default {
  setup() {
    const name = localStorage.getItem('fullname')
    const username = name.split(' ')[0]
    const initialName = username.substring(0, 2).toUpperCase()
    const form = ref({
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
    })
    const isPasswordVisible = ref(false)
    const isNewPasswordVisible = ref(false)
    const isConfirmPasswordVisible = ref(false)
    const formDialogStatus = ref(false)
    const removeDialogStatus = ref(false)
    const myDataDialog = ref(false)
    const userData = ref({})
    const picture = ref(null)

    return {
      username,
      initialName,
      formDialogStatus,
      removeDialogStatus,
      myDataDialog,
      userData,
      form,
      isPasswordVisible,
      isNewPasswordVisible,
      isConfirmPasswordVisible,
      picture,
      icons: {
        mdiAccount,
        mdiAccountCircleOutline,
        mdiLogoutVariant,
        mdiWallet,
        mdiKey,
        mdiEyeOffOutline,
        mdiEyeOutline,
        mdiLockOutline,
        mdiLockReset,
        mdiLockCheck,
        mdiClose,
        mdiEmailOutline,
        mdiPhone,
        mdiCardAccountDetailsOutline,
        mdiHandshakeOutline,
      },
    }
  },

  created() {
    this.picture = localStorage.getItem('picture')
  },

  methods: {
    ...mapActions('user', {
      fetchUserById: 'findById',
    }),

    async openMyData() {
      const id = localStorage.getItem('id')
      if (id) {
        const user = await this.fetchUserById(id)
        if (user) this.userData = user
      }
      this.userData.email = this.userData.email || localStorage.getItem('email') || ''
      this.myDataDialog = true
    },

    logout() {
      localStorage.removeItem('fullname')
      localStorage.removeItem('token')
      localStorage.removeItem('tenant')
      localStorage.removeItem('isAffiliate')
      localStorage.removeItem('picture')
      localStorage.removeItem('tokenApi')

      this.$router.push('/signin')
    },
    async submit() {
      const isValid = await this.$refs.changePassword.validate()
      if (isValid) {
        const hashedPasswords = {
          currentPassword: this.$sha256(this.form.currentPassword),
          newPassword: this.$sha256(this.form.newPassword),
          newPasswordConfirmation: this.$sha256(this.form.newPasswordConfirmation),
        }
        const res = await changePassword(hashedPasswords)
        if (res) {
          this.formDialogStatus = false
          this.$refs.changePassword.reset()
          this.form.currentPassword = ''
          this.form.newPassword = ''
          this.form.newPasswordConfirmation = ''
        }
      }
    },
    async openFormChangePassword() {
      this.formDialogStatus = true
    },
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>

<style lang="scss" scoped>
.profile-header {
  background: linear-gradient(135deg, rgba(6, 241, 26, 0.06) 0%, transparent 60%);
}

.info-row {
  display: flex;
  align-items: flex-start;
  padding: 8px 0;

  .info-icon {
    opacity: 0.5;
    margin-top: 2px;
    flex-shrink: 0;
  }

  .info-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    opacity: 0.5;
    margin-bottom: 2px;
    font-weight: 600;
  }

  .info-value {
    font-size: 0.875rem;
    font-weight: 500;
    margin-bottom: 0;
  }
}
</style>
